import { render } from "./MainInstancesDekstop.vue?vue&type=template&id=4ba1e6c3"
import script from "./MainInstancesDekstop.vue?vue&type=script&lang=js"
export * from "./MainInstancesDekstop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__